import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';
import { SidebarService } from '../../main/common/menu/service/sidebar.service';
import { UiService } from '../../shared/services/ui.service';

const SMALL_WIDTH_BREAKPOINT = 960;

@Component({
  selector: 'app-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  private _router: Subscription;

  autoLogin$: Observable<boolean>;

  mediaMatcher: MediaQueryList = matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
  url: string;
  sidePanelOpened;
  options = {
    collapsed: false,
    compact: false,
    boxed: false,
    dark: false,
  };

  @ViewChild('sidemenu', { static: false }) sidemenu;
  @ViewChild(PerfectScrollbarDirective, { static: false }) directiveScroll: PerfectScrollbarDirective;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(private _element: ElementRef, private router: Router, private sidebarService: SidebarService, public uiService: UiService, zone: NgZone) {
    this.mediaMatcher.addListener((mql) =>
      zone.run(() => {
        this.mediaMatcher = matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
      })
    );
  }

  ngOnInit(): void {
    this.url = this.router.url;
    this.autoLogin$ = this.uiService.autoLogin$;

    this._router = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      document.querySelector('.app-inner > .mat-drawer-content > div').scrollTop = 0;
      this.url = event.url;
      this.runOnRouteChange();
    });
  }

  ngOnDestroy(): void {
    this._router.unsubscribe();
  }

  runOnRouteChange(): void {
    if (this.isOver()) {
      this.sidemenu.close();
    }

    this.updatePS();
  }

  handleSidebarToggle(visible: boolean) {
    this.sidebarService.notifyShowHideSidebar(false);
    this.sidePanelOpened = false;
  }

  receiveOptions($event): void {
    this.sidebarService.notifyShowHideSidebar($event.collapsed || $event.compact);
    this.options = $event;
  }

  isOver(): boolean {
    switch (true) {
      case this.url === '/apps/messages':
      case this.url === '/apps/calendar':
      case this.url === '/apps/media':
      case this.url === '/apps/leaflet':
      case this.url === '/taskboard':
      case this.url === '/trailer-manager':
      case this.url === '/promotion-provider-editor':
      case this.url.indexOf('/pricing') === 0:
      case this.url.includes('/venue-editor'):
      case this.url.includes('/allocation-wizard'):
      case this.url.includes('/email-editor'):
      case this.url.includes('/ticket-layout'):
      case this.url.includes('/form/'):
      case this.url.includes('/invcount/new'):
      case this.url.includes('/invcounter'): {
        return true;
      }
      default: {
        return this.mediaMatcher.matches;
      }
    }
  }

  menuMouseOver(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = 'over';
    }
  }

  menuMouseOut(): void {
    if (this.mediaMatcher.matches && this.options.collapsed) {
      this.sidemenu.mode = 'side';
    }
  }
  // TODO: remove all perfectScrollbar related code
  updatePS(): void {
    if (!this.mediaMatcher.matches && !this.options.compact) {
      setTimeout(() => {
        this.directiveScroll?.update();
      }, 350);
    }
  }
}
